import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@/ui';
import { Typography } from 'antd';
import { Product, ProductsList } from '@/features/constructorProducts';

export const ConstructorProducts = () => {
  const { t } = useTranslation();

  return (
    <Container $paddingY={20}>
      <Container $marginBottom={30}>
        <Typography.Title level={3}>{t('Constructor products')}</Typography.Title>
      </Container>

      <ProductsList />
      <Product />
    </Container>
  );
};
